import React from 'react';

export function Card({ children, className = '', padded = true }) {
  return (
    <div className={`bg-white rounded-2xl border border-black/5 shadow-soft ${padded ? 'p-4' : ''} ${className}`}>
      {children}
    </div>
  );
}

export function SectionLabel({ children, className = '' }) {
  return (
    <div className={`text-[11px] font-extrabold text-ink-faint uppercase tracking-wide mb-2 ${className}`}>
      {children}
    </div>
  );
}

export function Row({ label, value, color, bold }) {
  return (
    <div className="flex justify-between items-center text-[13px] mb-1.5" style={{ color: color || undefined }}>
      <span className={bold ? 'font-extrabold' : ''}>{label}</span>
      <span className="font-bold">{value}</span>
    </div>
  );
}
